import { gql } from '@apollo/client';

export const FETCH_SERVIZI_OFFERTI = gql`
  query fetchServiziOfferti($where: Servizi_offertiWhereInput, $limit: Int!) {
    servizi_offertis(first: $limit, where: $where) {
      edges {
        node {
          objectId
          org_pointer {
            objectId
            nome
          }
          order
          servizi_offerti_default_pointer {
            objectId
            nome
          }
        }
      }
    }
  }
`;
